import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageHeader } from "@/components/PageHeader";
import { Services } from "@/components/Services";
import { WhatWeBuild } from "@/components/WhatWeBuild";
import { Packages } from "@/components/Packages";
import { CTASection } from "@/components/CTASection";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function ServicesPage() {
  usePageMeta({
    title: "Services | BrandZenith",
    description:
      "Twelve services under one roof — social media, websites, brand identity, content, design, SEO, performance marketing, AI automation, video, lead generation, UGC and influencer marketing.",
    path: "/services",
  });

  return (
    <>
      <Navbar />
      <main>
        <PageHeader
          overline="What We Do"
          title="Everything your"
          accent="brand needs."
          copy="From the first strategic decision to the last automated workflow — one studio, one system, one direction."
        />
        <Services showHeader={false} />
        <WhatWeBuild />
        <Packages />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
